<div class="availability-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>{{ data.rule ? 'edit' : 'add' }}</mat-icon>
      {{ data.rule ? 'Editar horario' : 'Añadir horario' }}
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="ruleForm" class="rule-form">

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="info-box">
            <mat-icon>person</mat-icon>
            <span>{{ data.staffName }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ng-container *ngIf="isEditMode; else createMultipleDaysTemplate">
            <app-autocomplete [control]="ruleForm.get('weekDay')" [config]="{
              label: 'Día de la semana',
              placeholder: 'Seleccionar día...',
              options: data.weekDays,
              required: true
            }">
            </app-autocomplete>
          </ng-container>
          <ng-template #createMultipleDaysTemplate>
  <!-- <app-multi-select-autocomplete [control]="weekDaysControl" [config]="{
              label: 'Días de la semana',
              placeholder: 'Seleccionar uno o varios días...',
              options: data.weekDays,
              required: true
            }">
            </app-multi-select-autocomplete> -->


            <app-multi-select-checkbox [control]="weekDaysControl" [config]="{
              label: 'Días de la semana',
              placeholder: 'Seleccionar uno o varios días...',
              options: data.weekDays,
              required: true
            }">
            </app-multi-select-checkbox>
          </ng-template>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <app-field [control]="ruleForm.get('startTime')" [config]="{ 
            label: 'Hora inicio', 
            type: 'time',
            required: true
          }">
          </app-field>
        </div>

        <div class="col-md-6">
          <app-field [control]="ruleForm.get('endTime')" [config]="{ 
            label: 'Hora fin', 
            type: 'time',
            required: true
          }">
          </app-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h6 class="section-subtitle">Vigencia (opcional)</h6>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Vigente desde</mat-label>
            <input matInput [matDatepicker]="pickerFrom" formControlName="effectiveFrom">
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <mat-hint>Dejar vacío para siempre</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Vigente hasta</mat-label>
            <input matInput [matDatepicker]="pickerTo" formControlName="effectiveTo">
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <mat-hint>Dejar vacío para siempre</mat-hint>
          </mat-form-field>
        </div>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button
      label="Cancelar"
      icon="close"
      variant="secondary"
      (click)="onCancel()">
    </app-button>
    <app-button 
      [label]="data.rule ? 'Guardar cambios' : 'Añadir horario'"
      icon="save" 
      variant="primary" 
      [disabled]="ruleForm.invalid"
      (click)="onSave()">
    </app-button>
  </mat-dialog-actions>

</div>
